var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7976 3.06575C23.8922 3.45126 22.9187 3.7134 21.8971 3.82905C22.9387 3.22767 23.7399 2.27547 24.1165 1.14209C23.143 1.69721 22.0613 2.10199 20.9115 2.32173C19.9901 1.37725 18.6761 0.783569 17.2258 0.783569C14.4375 0.783569 12.174 2.96167 12.174 5.64478C12.174 6.02643 12.218 6.39651 12.3062 6.75118C8.10766 6.55071 4.38588 4.61548 1.89801 1.67408C1.46133 2.39112 1.21295 3.22767 1.21295 4.11818C1.21295 5.80283 2.10233 7.29088 3.46044 8.16212C2.63115 8.13514 1.85394 7.91925 1.17289 7.55302C1.17289 7.57615 1.17289 7.59543 1.17289 7.61471C1.17289 9.97014 2.91159 11.9362 5.22318 12.3795C4.79852 12.4913 4.35383 12.553 3.89311 12.553C3.56861 12.553 3.24811 12.5222 2.94364 12.4644C3.58463 14.3957 5.45153 15.799 7.65896 15.8414C5.93228 17.1444 3.75289 17.9192 1.38922 17.9192C0.980588 17.9192 0.579966 17.8961 0.18335 17.8498C2.41882 19.23 5.07094 20.0357 7.92337 20.0357C17.2138 20.0357 22.2937 12.6301 22.2937 6.20762C22.2937 5.99944 22.2857 5.78741 22.2777 5.57924C23.2632 4.89304 24.1205 4.03723 24.7976 3.06575Z",
    fill: "#445A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSvg);
export default __webpack_public_path__ + "static/media/twitter_svg.a999470b5e5286714a0f91ad5eccdf3f.svg";
export { ForwardRef as ReactComponent };